/**
 * 403 Permission Denied view — shown when a user reaches a page (via
 * direct URL) they don't have permission for. UX-only; the backend
 * still enforces at the API layer.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { LockKey } from "@phosphor-icons/react";
import { useRbac } from "../lib/rbac";

export default function PermissionDenied({ required }) {
  const navigate = useNavigate();
  const { roleIds } = useRbac();
  return (
    <div
      className="flex flex-col items-center justify-center min-h-[70vh] p-6"
      data-testid="permission-denied-view"
    >
      <div className="max-w-md w-full border border-amber-300 bg-amber-50 p-8 rounded-sm">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 bg-amber-100 rounded-sm">
            <LockKey size={22} weight="bold" className="text-amber-700" />
          </div>
          <div>
            <div className="text-xs font-mono tracking-widest text-amber-800">
              ACCESS RESTRICTED
            </div>
            <h1 className="text-lg font-semibold text-zinc-900" data-testid="permission-denied-title">
              You don&apos;t have access to this page
            </h1>
          </div>
        </div>
        <p className="text-sm text-zinc-700 mb-2" data-testid="permission-denied-message">
          Your current role doesn&apos;t grant access to this module. If you
          believe this is a mistake, contact a Super Admin to update your
          role.
        </p>
        {required && required.length > 0 && (
          <div
            className="text-xs font-mono text-zinc-500 mt-3"
            data-testid="permission-denied-required"
          >
            Required: {required.join(" or ")}
          </div>
        )}
        <div className="text-xs font-mono text-zinc-500 mt-1">
          Assigned roles: {roleIds?.length ? roleIds.join(", ") : "—"}
        </div>
        <div className="mt-6 flex gap-2">
          <button
            className="gf-btn gf-btn-outline"
            onClick={() => navigate(-1)}
            data-testid="permission-denied-back"
          >
            ← Back
          </button>
          <button
            className="gf-btn gf-btn-primary"
            onClick={() => navigate("/dashboard")}
            data-testid="permission-denied-home"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
